/*
 * Pre-launch checkout lock
 *
 * Runtime half of the lock. Liquid already refuses to render the real checkout
 * button and the express payment buttons, so this file covers what Liquid
 * cannot: markup injected after render, links pasted or restored by the
 * browser, and pages that were already open when launch time arrives.
 *
 * Only loaded by snippets/prelaunch-head.liquid while the lock is active.
 */
(function () {
  var config = window.theme && window.theme.prelaunch;
  if (!config || !config.locked) return;

  var launchAt = Number(config.launchAt) * 1000;
  if (!isFinite(launchAt) || launchAt <= 0) launchAt = 0;

  /*
   * Trust the server clock, not the visitor's. A device set to a future date
   * must not be able to open checkout early, and a stale device clock must not
   * hold it shut after launch.
   */
  var clockSkew = Number(config.serverNow) * 1000 - Date.now();
  if (!isFinite(clockSkew)) clockSkew = 0;

  function now() {
    return Date.now() + clockSkew;
  }

  var RELOAD_FLAG = 'prelaunch:unlock-reloaded';

  var BLOCKED_SELECTOR = [
    '[data-prelaunch-checkout-button]',
    '[name="checkout"]',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]',
    'a[href*="/checkouts/"]',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    'shopify-buy-it-now-button',
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '[data-shopify-buttoncontainer]',
    '[data-buy-it-now]'
  ].join(',');

  var EXPRESS_SELECTOR = [
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    'shopify-buy-it-now-button',
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '[data-shopify-buttoncontainer]',
    '[data-buy-it-now]',
    '.shop-pay-terms'
  ].join(',');

  function nudge() {
    var buttons = document.querySelectorAll('[data-prelaunch-checkout-button]');

    for (var i = 0; i < buttons.length; i++) {
      (function (button) {
        button.classList.remove('is-nudged');
        // Force a reflow so the animation restarts on repeated clicks.
        void button.offsetWidth;
        button.classList.add('is-nudged');
        window.setTimeout(function () {
          button.classList.remove('is-nudged');
        }, 500);
      })(buttons[i]);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var node = event.target;
      if (node && node.nodeType === 3) node = node.parentElement;
      if (!node || typeof node.closest !== 'function') return;
      if (!node.closest(BLOCKED_SELECTOR)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      nudge();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var submitter = event.submitter;
      var action = form.getAttribute('action') || '';
      var isCheckoutSubmit = !!(submitter && submitter.name === 'checkout');

      // A plain POST to /cart is a quantity update, so leave it alone.
      if (!isCheckoutSubmit && action.indexOf('/checkout') === -1) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      nudge();
    },
    true
  );

  function stripExpressButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(EXPRESS_SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      nodes[i].remove();
    }
  }

  function watchForExpressButtons() {
    stripExpressButtons(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;

          if (node.matches && node.matches(EXPRESS_SELECTOR)) {
            node.remove();
          } else {
            stripExpressButtons(node);
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  /*
   * Pages that were already open at launch time reload themselves so Shopify
   * renders the real checkout button. The session flag stops a reload loop if
   * the server ever disagrees that launch has happened.
   */
  function unlockIfLaunched() {
    if (!config.autoUnlock || !launchAt) return false;
    if (now() < launchAt) return false;

    try {
      if (window.sessionStorage.getItem(RELOAD_FLAG)) return true;
      window.sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch (error) {
      // Private browsing can throw on sessionStorage; reloading once is fine.
    }

    window.location.reload();
    return true;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  class PrelaunchCountdown extends HTMLElement {
    connectedCallback() {
      this.target = Number(this.dataset.launchAt) * 1000;
      this.fields = {
        days: this.querySelector('[data-prelaunch-days]'),
        hours: this.querySelector('[data-prelaunch-hours]'),
        minutes: this.querySelector('[data-prelaunch-minutes]'),
        seconds: this.querySelector('[data-prelaunch-seconds]')
      };

      if (!isFinite(this.target) || this.target <= 0) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    tick() {
      var remaining = Math.max(0, this.target - now());

      if (remaining === 0) {
        window.clearInterval(this.interval);
        unlockIfLaunched();
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      this.write('days', pad(days));
      this.write('hours', pad(hours));
      this.write('minutes', pad(minutes));
      this.write('seconds', pad(seconds));
    }

    write(key, value) {
      var field = this.fields[key];
      if (field && field.textContent !== value) field.textContent = value;
    }
  }

  if (!window.customElements.get('prelaunch-countdown')) {
    window.customElements.define('prelaunch-countdown', PrelaunchCountdown);
  }

  document.documentElement.classList.add('prelaunch-locked');
  if (document.body) document.body.classList.add('prelaunch-locked');

  watchForExpressButtons();

  if (config.autoUnlock && launchAt && !unlockIfLaunched()) {
    // Safety net for pages where no countdown is rendered.
    window.setInterval(unlockIfLaunched, 5000);
  }
})();
